import { NgModule } from '@angular/core';
import { AnalyticEditComponent } from './analytic-edit/analytic-edit.component';
import { AnalyticListComponent } from './analytic-list/analytic-list.component';
import { AnalyticViewComponent } from 'src/app/analytic/analytic-view/analytic-view.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    AnalyticEditComponent,
    AnalyticListComponent,
    AnalyticViewComponent
  ],
  exports: [
    AnalyticViewComponent
  ],
})
export class AnalyticModule { }
